var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimeGreenPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3441 16.2526L17.3127 14.0963C17.0978 14.0047 16.8589 13.9854 16.6321 14.0413C16.4052 14.0972 16.2027 14.2253 16.0549 14.4063L13.8267 17.1286C10.3299 15.4799 7.51565 12.6657 5.8669 9.16876L8.58921 6.94059C8.77056 6.7931 8.89891 6.59054 8.95484 6.36358C9.01077 6.13662 8.99123 5.89762 8.89918 5.68276L6.74289 0.651421C6.64187 0.419803 6.46319 0.230695 6.23767 0.116705C6.01215 0.00271564 5.75393 -0.0290113 5.50752 0.0269955L0.835562 1.10514C0.597997 1.16 0.386041 1.29376 0.234288 1.48459C0.0825343 1.67543 -5.47252e-05 1.91206 2.72061e-08 2.15588C2.72061e-08 13.6785 9.33942 23 20.8441 23C21.088 23.0002 21.3248 22.9176 21.5157 22.7658C21.7066 22.6141 21.8404 22.4021 21.8953 22.1644L22.9735 17.4925C23.0291 17.2449 22.9967 16.9856 22.8818 16.7593C22.767 16.533 22.5768 16.3538 22.3441 16.2526Z",
    fill: "#B2D236"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimeGreenPhone);
export default __webpack_public_path__ + "static/media/LimeGreenPhone.07246ce687ccec85c7d6192eed8c3394.svg";
export { ForwardRef as ReactComponent };